export class UserRegistration{
    id       ?: number;
    userId   ?: string;
    firstName?: string;
    lastName ?: string;
    email    ?: string;
    phone    ?: string;
    CountryCode    ?: string;
    password ?: string;
    imageUrl ?: string;
    adress   ?: string;
    countryId?: number;
    cityId   ?: number;
    IsLogin   ?: boolean;
    constructor(item?:UserRegistration){
        item = item ? item : {};
        this.id = item.id ? item.id : 0;
        this.userId = item.userId ? item.userId : '';
        this.firstName = item.firstName ? item.firstName:'';
        this.lastName = item.lastName ? item.lastName : '';
        this.email = item.email ?item.email : '';
        this.phone = item.phone ? item.phone : '';
        this.password = item.password ? item.password :'';
        this.CountryCode = item.CountryCode ? item.CountryCode :'';
        this.imageUrl = item.imageUrl ? item.imageUrl : '';
        this.adress = item.adress ? item.adress : '';
        this.countryId = item.countryId ? item.countryId : 0;
        this.cityId = item.cityId ? item.cityId : 0;
        this.IsLogin = item.IsLogin ? item.IsLogin : false;
    }
}